<template>
  <panel-navigation>
    <div v-if="search" class="float-right ml-5 -mt-1">
      <v-select
        v-model="searches[0].properties.run_at_timezone"
        hide-details
        :items="['EST', 'PST']"
        outlined
        dense
        style="width: 100px; background: #FFFFFF;"
        @change="saveRunAt()"
      ></v-select>
    </div>

    <div v-if="search" class="float-right ml-5 -mt-1">
      <v-select
        v-model="searches[0].properties.run_at"
        hide-details
        :items="['12 AM','1 AM','2 AM','3 AM','4 AM','5 AM','6 AM','7 AM','8 AM','9 AM','10 AM','11 AM','12 PM','1 PM','2 PM','3 PM','4 PM','5 PM','6 PM','7 PM','8 PM','9 PM','10 PM','11 PM']"
        outlined
        dense
        style="width: 100px; background: #FFFFFF;"
        @change="saveRunAt()"
      ></v-select>
    </div>

    <div v-if="search" class="float-right ml-5 -mt-1 pt-3" style="font-size: 12px;">
      Run At:
    </div>

    <div v-if="search" class="float-right ml-5 -mt-1">
      <v-select
        v-model="searches[0].properties.frequency"
        hide-details
        :items="['7 days', '10 days', '14 days', '15 days', '30 days']"
        outlined
        dense
        style="width: 100px; background: #FFFFFF;"
        @change="saveRunAt()"
      ></v-select>
    </div>

    <div v-if="search" class="float-right ml-5 -mt-1 pt-3" style="font-size: 12px;">
      Frequency:
    </div>
      
    <h1 class="text-lg font-semibold mb-3">LSA Audit</h1>
  
    <hr class="border-b border-gray-100 mb-3">

    <v-skeleton-loader v-if="fetching" type="article, article, article"></v-skeleton-loader>

    <div v-else>
      <div v-if="me && search" class="dashboard-box stats-box w-full px-2 mb-5">
        <v-card class="pa-2" tile>
          <div class="p-3">
            <v-tabs>
              <v-tab v-for="(localSearch, index) in searches" :key="index" @click="search = localSearch; searchKey++;">
                {{ localSearch.keyword }}
              </v-tab>
              <v-tab @click="show_add_keyword = true" v-show="me.allowed_lsa_keywords > searches.length">
                + Add Keyword
              </v-tab>
            </v-tabs>
          </div>
        </v-card>
      </div>
        
      <div v-if="search && !show_add_keyword">
        <LSAAudit :search="search" :key="searchKey" />
      </div>
    
      <div v-else class="dashboard-box stats-box w-full px-2 -mx-2">
        <v-card class="pa-2" tile>
          <div class="p-3">
            <!-- Row 1: Google Autocomplete & Keyword -->
            <div class="lsa-audit-row">
              <div class="lsa-audit-field">
                <label class="field-label">Search Business (Google)</label>
                <vue-google-autocomplete 
                  id="rg_map_lsa_audit" 
                  classname="form-control" 
                  placeholder="Search for your business" 
                  v-on:placechanged="selectPlace" 
                  types="establishment"
                ></vue-google-autocomplete>
              </div>

              <div class="lsa-audit-field">
                <label class="field-label">Keyword</label>
                <input type="text" v-model="lsa_keyword" placeholder="Keyword (e.g. roofer)" class="audit-input" />
              </div>
            </div>

            <!-- Row 2: Company Name & Phone -->
            <div class="lsa-audit-row">
              <div class="lsa-audit-field">
                <label class="field-label">LSA Company Name</label>
                <input type="text" v-model="lsa_company_name" placeholder="LSA Company Name" class="audit-input" />
              </div>

              <div class="lsa-audit-field">
                <label class="field-label">Phone Number</label>
                <input type="text" v-model="lsa_phone" placeholder="Phone Number" class="audit-input" />
              </div>
            </div>

            <!-- Row 3: Address & Website -->
            <div class="lsa-audit-row">
              <div class="lsa-audit-field">
                <label class="field-label">Street Address</label>
                <input type="text" v-model="lsa_address" placeholder="Street Address" class="audit-input" />
              </div>

              <div class="lsa-audit-field">
                <label class="field-label">Website</label>
                <input type="text" v-model="lsa_website" placeholder="Website URL" class="audit-input" />
              </div>
            </div>

            <!-- Row 4: City, State, Zip -->
            <div class="lsa-audit-row">
              <div class="lsa-audit-field-third">
                <label class="field-label">City</label>
                <input type="text" v-model="lsa_city" placeholder="City" class="audit-input" />
              </div>

              <div class="lsa-audit-field-third">
                <label class="field-label">State</label>
                <input type="text" v-model="lsa_state" placeholder="State" class="audit-input" />
              </div>

              <div class="lsa-audit-field-third">
                <label class="field-label">Zip Code</label>
                <input type="text" v-model="lsa_zip" placeholder="Zip Code" class="audit-input" />
              </div>
            </div>

            <!-- Run Button -->
            <div class="lsa-audit-button mt-4">
              <div v-if="!show_add_keyword" class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-4 rounded cursor-pointer float-right" @click="submitLsaAudit();">
                <i class="fa fa-plus mr-2"></i> RUN AUDIT
              </div>

              <div v-if="show_add_keyword" class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-4 rounded cursor-pointer float-right" @click="submitLsaAudit();">
                <i class="fa fa-plus mr-2"></i> ADD KEYWORD
              </div>
            </div>

            <div style="clear: both;"></div>

            <br />
            <h2>Notes:</h2>

            <div style="padding-top: 10px; font-size: 12px;">
              - Search for your exact business in its location, we will use that location to search for competitors nearby<br />
              - Enter exact keyword such as "roofer", "HVAC" or "family lawyer" (without the quotes)<br />
              - If the business has a different name on LSA than the GBP profile, make sure that is updated in the LSA Company Name field<br />
              - Do not include words like "near me" or "in [city]" in the keyword box<br />
              - Once you submit the audit, the keyword cannot be changed and it has to match your main job as shown in your LSA profile<br />
              - This report will run once every week to track changes in rankings and visibility<br />
              - The report will run at 10 AM PST, please check results around that time after your submit the information
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </panel-navigation>
</template>

<script>
import { mapState } from 'vuex'
import PanelNavigation from '@/components/PanelNavigation.vue'
import axios from 'axios'
import moment from 'moment'
import LSAAudit from '@/views/local-recon/ReportsTemplates/LSAAudit.vue'
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  metaInfo () {
    return {
      title: "LSA Audit | " + this.$appName
    }
  },

  computed: {
    ...mapState({
      me: state => state.me.me,
    })
  },

  components: {
    PanelNavigation,
    LSAAudit,
    VueGoogleAutocomplete
  },

  data () {
    return {
      business_location: {},
      lsa_keyword: "",
      lsa_company_name: "",
      lsa_address: "",
      lsa_city: "",
      lsa_state: "",
      lsa_zip: "",
      lsa_phone: "",
      lsa_website: "",

      show_add_keyword: false,
      searches: [],
      search: null,
      searchKey: 0,
      fetching: true
    }
  },

  methods: {
    populateFromUser() {
      if (this.me) {
        this.lsa_keyword = this.me.main_keyword || "";
        this.lsa_company_name = this.me.company_name || "";
        this.lsa_address = this.me.address || "";
        this.lsa_city = this.me.city || "";
        this.lsa_state = this.me.state || "";
        this.lsa_zip = this.me.zip || "";
        this.lsa_phone = this.me.phone || "";
        this.lsa_website = this.me.domain || "";
        
        // Populate place details object if stored on user
        this.business_location = {
          place_id: this.me.place_id || this.me.google_place_id || null,
          name: this.me.company_name || "",
          formatted_address: `${this.me.address || ''}, ${this.me.city || ''}, ${this.me.state || ''} ${this.me.zip || ''}`.trim(),
          formatted_phone_number: this.me.phone || "",
          website: this.me.domain || ""
        };
      }
    },

    selectPlace(addressData, placeResultData, id) {
      this.business_location = placeResultData;

      this.lsa_company_name = placeResultData.name || this.lsa_company_name;
      this.lsa_phone = placeResultData.formatted_phone_number || placeResultData.international_phone_number || this.lsa_phone;
      this.lsa_website = placeResultData.website || this.lsa_website;

      // Extract address components from Google Places response
      if (addressData) {
        this.lsa_address = (addressData.street_number ? addressData.street_number + ' ' : '') + (addressData.route || addressData.name || '');
        this.lsa_city = addressData.locality || addressData.sublocality || '';
        this.lsa_state = addressData.administrative_area_level_1 || '';
        this.lsa_zip = addressData.postal_code || '';
      }
    },

    async submitLsaAudit() {
      if (!this.lsa_keyword) {
        alert("Please enter a keyword.");
        return;
      }

      this.fetching = true;

      // Ensure business location holds explicit user values
      this.business_location.name = this.lsa_company_name;
      this.business_location.address = this.lsa_address;
      this.business_location.city = this.lsa_city;
      this.business_location.state = this.lsa_state;
      this.business_location.zip = this.lsa_zip;
      this.business_location.phone = this.lsa_phone;
      this.business_location.website = this.lsa_website;

      let response = await axios.post(process.env.VUE_APP_API_ENDPOINT + '/local-recon/submit-lsa-audit', {
        widget_uuid: null,
        business_location: this.business_location,
        keyword: this.lsa_keyword,
        lsa_company_name: this.lsa_company_name,
        lsa_address: this.lsa_address,
        lsa_city: this.lsa_city,
        lsa_state: this.lsa_state,
        lsa_zip: this.lsa_zip,
        lsa_phone: this.lsa_phone,
        lsa_website: this.lsa_website,
        ongoing: 1
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        },
      });

      this.getSearch();
      this.show_add_keyword = false;
    },

    async getSearch() {
      this.searchKey++;

      let response = await axios.get(process.env.VUE_APP_API_ENDPOINT + '/local-recon/get-business-lsa-audit', {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        },
      });

      if (response.data.search) this.search = response.data.search;

      if (response.data.searches) {
        this.searches = response.data.searches;
        for (var i in this.searches) {
          if (this.searches[i].properties && this.searches[i].properties.searches) {
            this.searches[i].properties.searches.list.reverse();
          }
        }
        this.search = response.data.searches[0];
      }

      if (this.search && this.search.properties) {
        if (!this.search.properties.run_at) {
          this.search.properties.run_at = '10 AM';
          this.search.properties.run_at_timezone = 'PST';
        }
        if (!this.search.properties.frequency) {
          this.search.properties.frequency = '30 days';
        }
      }

      this.fetching = false;
    },

    async saveRunAt() {
      await axios.post(process.env.VUE_APP_API_ENDPOINT + '/local-recon/save-run-at', {
        id: this.search.id,
        run_at: this.search.properties.run_at,
        run_at_timezone: this.search.properties.run_at_timezone
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        },
      });
    }
  },

  created() {
    this.getSearch();
  },

  mounted() {
    this.populateFromUser();
  },

  watch: {
    me: {
      handler(newVal) {
        if (newVal) this.populateFromUser();
      },
      immediate: true
    },
    'search': {
      handler() {
        if (this.search) this.saveRunAt();
      }
    }
  }
}
</script>

<style scoped>
.lsa-audit-row {
  display: flex;
  gap: 15px;
  margin-bottom: 12px;
}

.lsa-audit-field {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.lsa-audit-field-third {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.field-label {
  font-size: 11px;
  font-weight: 600;
  color: #616161;
  margin-bottom: 4px;
}

.audit-input, #rg_map_lsa_audit {
  padding-left: 15px;
  height: 48px;
  width: 100%;
  outline: none;
  background: #efefef !important;
  border-radius: 5px;
  font-size: 12px;
  border: none !important;
}

@media screen and (max-width: 600px) {
  .lsa-audit-row {
    flex-direction: column;
    gap: 10px;
  }
}
</style>